import styled from "@emotion/styled"
import { IconButton, Typography } from "@mui/material"
import Drawer from "@mui/material/Drawer"
import Image from "next/image"
import * as React from "react"
import { getNonUmbracoUrl, Link } from "utils"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"
import CloseIcon from "../../icons/CloseIcon"
import { sharedColors } from "../../theme/colors"
import { HeaderData } from "../Layout"

const StyledDrawer = styled(Drawer)`
  & .MuiPaper-root {
    display: flex;
    border-radius: 25px 25px 0px 0px !important;
    overflow: hidden;
    /* Cards */
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
    padding: 20px 16px 24px 16px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
`

const TopBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  text-align: center;
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

const IconsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 24px;
  row-gap: 20px;
`

const IconItem = styled(Link)`
  display: flex;
  padding: 16px 8px;
  flex-direction: column;
  height: 115px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 100%;
  border-radius: 12px;
  text-decoration: none;
  border: 1px solid ${sharedColors.borderGray};
  &:hover {
    border: 1px solid ${sharedColors.labelGray};
  }
`

const StyledIconButton = styled.div`
  position: absolute;
  top: 30px;
  left: 25px;
`

export default function ContactDrawer({
  open,
  setOpen,
  header,
}: {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  header: HeaderData
}) {
  const toggleDrawer = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")
    ) {
      return
    }

    setOpen(!open)
  }

  const handleClose = () => {
    setOpen(false)
  }
  return (
    <StyledDrawer anchor="bottom" open={open} onClose={toggleDrawer}>
      <TopBox>
        <StyledIconButton>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </StyledIconButton>
        <Image
          src={"/icons/headphones.svg"}
          alt="headphones"
          width={88}
          height={88}
        />
        <TextBox>
          <Typography variant="h3">{header.contactTitle}</Typography>
          <Typography variant="body1">{header.contactSubtitle}</Typography>
        </TextBox>
      </TopBox>
      <IconsGrid>
        {header.itemsList.map((item) => (
          <IconItem
            key={item.label}
            href={getNonUmbracoUrl(item.link)}
            onClick={handleClose}
          >
            <Image
              src={getUmbracoMediaUrl(item.icon)}
              alt={item.label}
              width={40}
              height={40}
            />
            <Typography variant="body2" style={{ textAlign: "center" }}>
              {item.label.replace(/\u2028/g, " ")}
            </Typography>
          </IconItem>
        ))}
      </IconsGrid>
    </StyledDrawer>
  )
}
